module.exports = __webpack_public_path__ + "img/fukuoka.756b3dfa.jpg";